module.exports = __webpack_public_path__ + "a39ab3240dfb2faf69b7508f40c00e35.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-cool.png
// module id = 1820
// module chunks = 0